/** @format */

import React from 'react'
import { _$, Tooltip, Message, Tag } from '@king-design/react'
import { TablePage } from 'src/components'
import { ContactGroupUpdate } from './constants'
import styled from 'styled-components'
import API from 'src/api/ApiContacts'
import { request } from 'src/utils'

const ContactGroupTable: React.FC<ContactGroupUpdate> = ({
  className,
  usrgrpid,
  name,
  description,
  contactIds,
  updateGroupList
}) => {
  const removeUser = async userId => {
    const userIdList = contactIds.filter(user => user.userid !== userId).map(({ userid }) => userid)
    if (userIdList?.length) {
      const result = await request(API.updateUserGroup, {
        method: 'POST',
        data: {
          UserGrpId: usrgrpid,
          Name: name,
          UserIdList: userIdList,
          Description: description
        }
      })
      const { code, message } = result
      if (code === 'Success') {
        updateGroupList()
        Message.success(message)
      }
    } else {
      Message.warning(_$('联系组需至少包含一个联系人'))
    }
  }

  // table scheme
  const tableScheme = {
    name: {
      title: _$('姓名'),
      template({ name }) {
        return <p className="text-overflow">{name}</p>
      }
    },
    status: {
      title: _$('状态'),
      template({ status }) {
        return (
          <>
            {status === 1 ? (
              <Tag type="success">{_$('启用')}</Tag>
            ) : (
              <Tag type="danger">{_$('禁用')}</Tag>
            )}
          </>
        )
      }
    },
    phone: {
      title: _$('电话')
    },
    email: {
      title: _$('邮箱'),
      template({ email }) {
        return <p className="text-overflow">{email}</p>
      }
    },
    active: {
      title: _$('操作'),
      template(item) {
        const { userid } = item
        return (
          <div className="ksc-space">
            <Tooltip
              content={_$('确定将该联系人从组中移除')}
              confirm
              theme="light"
              trigger="click"
              onOk={() => {
                removeUser(userid)
              }}
            >
              <a className="primary-color">{_$('移除')}</a>
            </Tooltip>
          </div>
        )
      }
    }
  }

  return (
    <div className={className}>
      <TablePage
        tableProps={{
          scheme: tableScheme,
          data: contactIds,
          checkType: 'none',
          resizable: true
        }}
      ></TablePage>
    </div>
  )
}
export default styled(ContactGroupTable)`
  .k-table p {
    margin-bottom: 0;
  }
`
